module.exports = __webpack_public_path__ + "img/stackslash-103-mobile.6c3d2d7f.jpg";